// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lr-mt {
    margin-top: 38px;
}
.lr-car-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    max-width: 320px;
    height: 220px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 12px;
    background: var(--externalDamageUrl) center 43px no-repeat;
}
.lr-van-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    max-width: 320px;
    height: 220px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 12px;
}
.lr-van-container::before {
    content: "";
    position: absolute;
    width: 100%;
    max-width: 320px;
    height: 320px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 12px;
    background: var(--externalDamageUrl) center no-repeat;
    object-fit: contain;
    z-index: -1;
  }
.lr-suv-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    max-width: 320px;
    height: 220px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 12px;
  }
  .lr-suv-container::before {
    content: "";
    position: absolute;
    width: 100%;
    max-width: 325px;
    height: 320px;
    margin-left: auto;
    margin-right: auto;
    z-index: -1;
    padding-top: 12px;
    background: var(--externalDamageUrl) center no-repeat;
    object-fit: contain;
  }
.lr-motorcycle-container {
  display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    max-width: 320px;
    height: 220px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 12px;
}
.lr-motorcycle-container::before {
  content: "";
  position: absolute;
  width: 100%;
  max-width: 320px;
  height: 230px;
  margin-left: auto;
  margin-right: auto;
  background: var(--externalDamageUrl) center no-repeat;
  transform: rotate(-0.25turn);
  object-fit: contain;
}
.lr-counter-row-1,
.lr-counter-row-2 {
    display: flex;
}
.lr-counter-row-2 {
    padding: 20px 22px 0 22px;
    justify-content: space-between;
}
.lr-counter-label {
    font-size: 10px;
    font-weight: bold;
    line-height: 12px;
    text-transform: uppercase;
}
.lr-counter-row-1 .lr-counter {
    display: flex;
    align-items: center;
    width: calc(50% - 16px);
}
.lr-counter-row-2 .lr-counter {
    display: flex;
    flex-direction: column;
}
.lr-counter-row-1 .lr-counter-label {
    padding-left: 8px;
}
.lr-counter-row-2 .lr-counter-label {
    padding-top: 8px;
    text-align: center;
}
.lr-options-container {
    margin-top: 22px;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    max-width: 345px;
    overflow: auto;
}
.lr-options-heading {
    color: #222222;
    font-family: "Source Sans Pro";
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    padding: 5px;
}
.lr-damage-option {
    padding: 5px 16px;
    color: #6e6e6e;
    font-family: "Source Sans Pro";
    font-size: 14px;
    line-height: 21px;
    float: left;
    margin-right: 10px;
    margin-bottom: 10px;
    box-sizing: border-box;
    border: 1px solid #403C3C;
    border-radius: 8px;
    background-color: #FFFFFF;
}
.lr-damage-option:last-child {
    margin-right: 0;
}
.lr-damage-option.lr-selected {
    color: #2D2929;
    font-weight: 600;
    box-sizing: border-box;
    border: 1px solid #403C3C;
    border-radius: 8px;
    background-color: #F3F2F2;
}
.lr-ending-row-bottom-spacing {
    margin-bottom: 30px;
}
`, "",{"version":3,"sources":["webpack://./projects/lossreporting-library/src/lib/damage-details/exterior-damage/exterior-damage.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,0DAA0D;AAC9D;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,qDAAqD;IACrD,mBAAmB;IACnB,WAAW;EACb;AACF;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,qDAAqD;IACrD,mBAAmB;EACrB;AACF;EACE,aAAa;IACX,sBAAsB;IACtB,8BAA8B;IAC9B,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,qDAAqD;EACrD,4BAA4B;EAC5B,mBAAmB;AACrB;AACA;;IAEI,aAAa;AACjB;AACA;IACI,yBAAyB;IACzB,8BAA8B;AAClC;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,cAAc;IACd,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;AAChB;AACA;IACI,iBAAiB;IACjB,cAAc;IACd,8BAA8B;IAC9B,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;AAC7B;AACA;IACI,eAAe;AACnB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;AAC7B;AACA;IACI,mBAAmB;AACvB","sourcesContent":[".lr-mt {\n    margin-top: 38px;\n}\n.lr-car-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    width: 100%;\n    max-width: 320px;\n    height: 220px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 12px;\n    background: var(--externalDamageUrl) center 43px no-repeat;\n}\n.lr-van-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    width: 100%;\n    max-width: 320px;\n    height: 220px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 12px;\n}\n.lr-van-container::before {\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    max-width: 320px;\n    height: 320px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 12px;\n    background: var(--externalDamageUrl) center no-repeat;\n    object-fit: contain;\n    z-index: -1;\n  }\n.lr-suv-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    width: 100%;\n    max-width: 320px;\n    height: 220px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 12px;\n  }\n  .lr-suv-container::before {\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    max-width: 325px;\n    height: 320px;\n    margin-left: auto;\n    margin-right: auto;\n    z-index: -1;\n    padding-top: 12px;\n    background: var(--externalDamageUrl) center no-repeat;\n    object-fit: contain;\n  }\n.lr-motorcycle-container {\n  display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    width: 100%;\n    max-width: 320px;\n    height: 220px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 12px;\n}\n.lr-motorcycle-container::before {\n  content: \"\";\n  position: absolute;\n  width: 100%;\n  max-width: 320px;\n  height: 230px;\n  margin-left: auto;\n  margin-right: auto;\n  background: var(--externalDamageUrl) center no-repeat;\n  transform: rotate(-0.25turn);\n  object-fit: contain;\n}\n.lr-counter-row-1,\n.lr-counter-row-2 {\n    display: flex;\n}\n.lr-counter-row-2 {\n    padding: 20px 22px 0 22px;\n    justify-content: space-between;\n}\n.lr-counter-label {\n    font-size: 10px;\n    font-weight: bold;\n    line-height: 12px;\n    text-transform: uppercase;\n}\n.lr-counter-row-1 .lr-counter {\n    display: flex;\n    align-items: center;\n    width: calc(50% - 16px);\n}\n.lr-counter-row-2 .lr-counter {\n    display: flex;\n    flex-direction: column;\n}\n.lr-counter-row-1 .lr-counter-label {\n    padding-left: 8px;\n}\n.lr-counter-row-2 .lr-counter-label {\n    padding-top: 8px;\n    text-align: center;\n}\n.lr-options-container {\n    margin-top: 22px;\n    margin-left: auto;\n    margin-right: auto;\n    width: 100%;\n    max-width: 345px;\n    overflow: auto;\n}\n.lr-options-heading {\n    color: #222222;\n    font-family: \"Source Sans Pro\";\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 24px;\n    padding: 5px;\n}\n.lr-damage-option {\n    padding: 5px 16px;\n    color: #6e6e6e;\n    font-family: \"Source Sans Pro\";\n    font-size: 14px;\n    line-height: 21px;\n    float: left;\n    margin-right: 10px;\n    margin-bottom: 10px;\n    box-sizing: border-box;\n    border: 1px solid #403C3C;\n    border-radius: 8px;\n    background-color: #FFFFFF;\n}\n.lr-damage-option:last-child {\n    margin-right: 0;\n}\n.lr-damage-option.lr-selected {\n    color: #2D2929;\n    font-weight: 600;\n    box-sizing: border-box;\n    border: 1px solid #403C3C;\n    border-radius: 8px;\n    background-color: #F3F2F2;\n}\n.lr-ending-row-bottom-spacing {\n    margin-bottom: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
